// extracted by mini-css-extract-plugin
export var actionButton = "_79-1";
export var actionButtons = "_79-2";
export var actions = "_79-0";
export var aiUnread = "_79-10";
export var alignCenter = "_79-h";
export var backWrapper = "_79-3";
export var cellContainer = "_79-4";
export var checkboxContainer = "_79-5";
export var contentContainer = "_79-6";
export var contentHeader = "_79-8";
export var conversationsTableWrapper = "_79-s";
export var draftReplyBadgeContainer = "_79-m";
export var dropdownItem = "_79-b";
export var dropdownItemsContainer = "_79-a";
export var dropdownTitle = "_79-c";
export var errorIcon = "_79-7";
export var filter = "_79-d";
export var gray = "_79-i";
export var headerActionButtons = "_79-e";
export var headerCheckboxContainer = "_79-f";
export var icon = "_79-j";
export var menuContainer = "_79-k";
export var noMoreTicketsIcon = "_79-12";
export var noMoreTicketsSubText = "_79-13";
export var oneLine = "_79-l";
export var optionsButton = "_79-n";
export var plus = "_79-o";
export var portalButtonsWrapper = "_79-g";
export var red = "_79-p";
export var scrolledTop = "_79-9";
export var search = "_79-q";
export var selectedConversationsCount = "_79-r";
export var spinner = "_79-t";
export var strong = "_79-u";
export var summaryCell = "_79-v";
export var tableContainer = "_79-11";
export var tagContainer = "_79-w";
export var threeDots = "_79-x";
export var twoLines = "_79-y";
export var unread = "_79-z";